/// <reference types="./updateStatus.d.ts" />
import { ok, } from '@dossierhq/core';
import { queryRun } from '../QueryFunctions.js';
import { getTransactionTimestamp } from '../SqliteTransaction.js';
import { getEntitiesUpdatedSeq } from './getEntitiesUpdatedSeq.js';
export async function adminEntityUpdateStatus(database, context, status, reference, syncEvent) {
    const now = syncEvent?.createdAt ?? getTransactionTimestamp(context.transaction);
    const updatedReqResult = await getEntitiesUpdatedSeq(database, context);
    if (updatedReqResult.isError())
        return updatedReqResult;
    const result = await queryRun(database, context, {
        text: `UPDATE entities SET
        updated_at = ?1,
        updated_seq = ?2,
        status = ?3
      WHERE id = ?4`,
        values: [
            now.toISOString(),
            updatedReqResult.value,
            status,
            reference.entityInternalId,
        ],
    });
    if (result.isError())
        return result;
    return ok({ updatedAt: now });
}
//# sourceMappingURL=updateStatus.js.map